export default __webpack_public_path__ + "static/media/audio1.630aa7f0.m4a";